<template>
  <router-link
    class="vm-nav-tab-item"
    :to="{name:name, query:query}"
    :tag="tag"
    :disabled="disabled"
    :replace="is_replace"
    :event="!disabled ? 'click' : ''"
  >
    {{text}}
    <span class="line-on"></span>
  </router-link>
</template>

<script>
export default {
  name: 'nav-tab-item',
  props: {
    text: {
      default: '',
    },
    name: {
      default: '',
    },
    disabled: {
      default: false,
    },
    query: {
      type: Object,
      default() {
        return {};
      },
    },
    tag: {
      default: 'a',
    },
    is_replace: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {
    click() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="stylus" scoped>
.vm-nav-tab-item {
  color: $black-5;
  font-size: fs2rem(16);
  cursor: pointer;
  position: relative;
  padding-bottom: 8px;
  &:hover {
    color: $black;
  }
  &.type-1.on{
    .line-on{
      width: 25%;
    }
  }
  &.on {
    color: $purple;
    font-weight:bold;

    .line-on {
      display: block;
      background: $purple;
      width: 50%;
      height: 2px;
      position: absolute;
      left:0;
      bottom:0;
      // margin-top: px2rem(8);
      
    }
  }
}
</style>
